// Espelha o contador de notificações não lidas no ícone do app:
// - Windows: overlay icon (bolinha) no canto do botão da taskbar.
// - macOS/Linux: badge numérico no dock.
// Sem efeito no navegador — window.desktop só existe dentro do Electron.

type DesktopBadgeApi = {
  isElectron?: boolean;
  setBadgeCount?: (count: number, iconDataUrl: string | null) => void;
};

function getDesktop(): DesktopBadgeApi | undefined {
  if (typeof window === 'undefined') return undefined;
  return (window as unknown as { desktop?: DesktopBadgeApi }).desktop;
}

/**
 * Desenha um badge circular vermelho com o número (estilo "bolinha de
 * notificação") e devolve um PNG em data URL, pronto para virar overlay icon na
 * taskbar. Acima de 99 mostra "99+". O processo principal posiciona/encolhe a
 * imagem no canto do ícone, então desenhamos o círculo preenchendo todo o canvas.
 */
function renderBadgeIcon(count: number): string | null {
  if (count <= 0) return null;

  const label = count > 99 ? '99+' : String(count);
  const size = 32; // base nítida em telas hiDPI; o Windows reduz no DPI padrão.
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  // Bolinha vermelha (convenção universal de badge de notificação).
  ctx.fillStyle = '#ff3b30';
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
  ctx.fill();

  // Número branco, centralizado; a fonte encolhe conforme o nº de dígitos.
  ctx.fillStyle = '#ffffff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  const fontSize = label.length >= 3 ? 13 : label.length === 2 ? 17 : 21;
  ctx.font = `bold ${fontSize}px -apple-system, "Segoe UI", Roboto, sans-serif`;
  // +1 no eixo Y compensa o baseline ótico da fonte.
  ctx.fillText(label, size / 2, size / 2 + 1);

  return canvas.toDataURL('image/png');
}

/**
 * Atualiza o contador no ícone da taskbar/dock. No-op fora do app desktop.
 */
export function setDesktopBadge(count: number): void {
  const desktop = getDesktop();
  if (!desktop?.isElectron || !desktop.setBadgeCount) return;
  const safe = Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
  desktop.setBadgeCount(safe, renderBadgeIcon(safe));
}
